
import { Component, Prop, Vue } from "vue-property-decorator";
import MatchInterface from "@/libs/model/MatchInterface";

@Component({
  components: {},
  computed: {
  },
})
export default class TeamsComponent extends Vue
{
  name: 'TeamsComponent';
  @Prop() matchdata: MatchInterface;
  @Prop() type: string;

  get teamData() {
    if(typeof(this.matchdata.matchInfo.contestant) !== 'undefined' && this.type == "first"){
      return this.matchdata.matchInfo.contestant[0].name;
    }else if(typeof(this.matchdata.matchInfo.contestant) !== 'undefined' && this.type == "second"){
      return this.matchdata.matchInfo.contestant[1].name;
    }
    return "TBD";
  }
  get teamDataClass() {

    // Add Winning/Losing Team Class
    if(this.matchdata.liveData.matchDetails.matchStatus === "Played") {
      if(typeof(this.matchdata.liveData) !== 'undefined' && this.type == "first"){
        if(typeof(this.matchdata.liveData.matchDetails.scores)  !== 'undefined'){
          if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
            if(this.matchdata.liveData.matchDetails.scores.pen.home > this.matchdata.liveData.matchDetails.scores.pen.away) {
              return "winning-team";
            } else if(this.matchdata.liveData.matchDetails.scores.pen.home < this.matchdata.liveData.matchDetails.scores.pen.away) {
              return "losing-team";
            }
          }

          if(this.matchdata.liveData.matchDetails.scores.ft.home > this.matchdata.liveData.matchDetails.scores.ft.away) {
            return "winning-team";
          } else if(this.matchdata.liveData.matchDetails.scores.ft.home < this.matchdata.liveData.matchDetails.scores.ft.away) {
            return "losing-team";
          }
        }
      } else if(typeof(this.matchdata.liveData) !== 'undefined' && this.type == "second"){
        if(typeof(this.matchdata.liveData.matchDetails.scores)  !== 'undefined'){
          if(typeof(this.matchdata.liveData.matchDetails.scores.pen) != "undefined" && this.matchdata.liveData.matchDetails.scores.pen !== null) {
            if(this.matchdata.liveData.matchDetails.scores.pen.home < this.matchdata.liveData.matchDetails.scores.pen.away) {
              return "winning-team";
            }

            if(this.matchdata.liveData.matchDetails.scores.pen.home > this.matchdata.liveData.matchDetails.scores.pen.away) {
              return "losing-team";
            }
          }

          if(this.matchdata.liveData.matchDetails.scores.ft.home < this.matchdata.liveData.matchDetails.scores.ft.away) {
            return "winning-team";
          } else if(this.matchdata.liveData.matchDetails.scores.ft.home > this.matchdata.liveData.matchDetails.scores.ft.away) {
            return "losing-team";
          }
        }
      }
    }

  }
  get myflagData() {
    if(typeof(this.matchdata.matchInfo.contestant) !== 'undefined' && this.type == "first"){
        return this.matchdata.matchInfo.contestant[0].code+".png";
    }else if(typeof(this.matchdata.matchInfo.contestant) !== 'undefined' && this.type == "second"){
      return this.matchdata.matchInfo.contestant[1].code+".png";
    }
    return "TBD.png";
  }

}
